const ru = {
  lead: "Семьи, туристы, лыжники и путешественники идут за троллями пешком, на лыжах и на лодке. Поставьте троллей у своей двери — и охота приведёт новых гостей прямо к вам, каким бы ни было ваше место.",
  areasKicker: "Отрасли",
  areasTitle: "Найдите свою отрасль.",
  bannerKicker: "У вас бизнес в этой сфере?",
  bannerTitle: "Больше клиентов. Новые посетители.",
  cta: "Стать партнёром Trollfossjakten",
  placesLike: "Подходит для",
  ideaTitle: "Идея тролля",
  cats: {
    hotels: {
      name: "Отели и гостиничные сети",
      short: "Превратите охотников за троллями в гостей с ночёвкой.",
      lead: "Тролль у входа, в саду или на собственной тропе отеля даёт семьям повод остаться на ночь — и вернуться в следующем сезоне.",
      idea: "Тролль-носильщик с чемоданами у двери, тролль-завтрак у окна с буфетом и ночной тролль под северным сиянием на террасе на крыше.",
      types: ["Гостиничные сети", "Исторические отели", "Отели у фьордов и в горах", "Курорты и спа-отели", "Прибрежные отели", "Домики и лоджи"],
    },
    restaurants: {
      name: "Рестораны и сети кафе",
      short: "Голодные охотники — прямо у вашей двери.",
      lead: "Охота на троллей пробуждает аппетит. Поставьте троллей у своих ресторанов, и игроки смогут сделать предзаказ и оплатить через Vipps по дороге.",
      idea: "Тролль-повар, помешивающий суп, тролль-пиццайоло на террасе и кофейный тролль, охраняющий лучшее место у окна.",
      types: ["Сети пиццерий и бургерных", "Сети кофеен", "Стейк-хаусы", "Семейные рестораны", "Суши и азиатская кухня", "Сети пекарен"],
    },
    activities: {
      name: "Активный отдых и впечатления",
      short: "Ещё одна причина забронировать у вас.",
      lead: "Поездки по фьордам, рафтинг, сафари и походы с гидом — идеальная территория для троллей. Ваши тролли превращают экскурсию в квест и приводят игроков к вашей стойке бронирования.",
      idea: "Тролль в спасательном жилете у причала для каяков, ледниковый тролль на льду и тролль сияния, который появляется только на зимних сафари.",
      types: ["Туры по фьордам и круизы", "Прибрежные плавания", "Рафтинг и каяки", "Арктические сафари и сияние", "Приключенческие туры", "Центры дикой природы"],
    },
    ski: {
      name: "Горнолыжные курорты и горы",
      short: "Тролли на склонах всю зиму.",
      lead: "Тролли у подъёмников, на лыжне и в кафе на вершине превращают каждый лыжный день в охоту — и возвращают семьи летом.",
      idea: "Лыжный тролль на старых деревянных лыжах у подъёмника, снежный тролль на лесной лыжне и тролль на вершине с горячим какао.",
      types: ["Горнолыжные курорты", "Центры беговых лыж", "Горные посёлки", "Летние лыжи", "Апре-ски и лоджи", "Лыжные школы"],
    },
    attractions: {
      name: "Достопримечательности и музеи",
      short: "Пусть тролли расскажут вашу историю.",
      lead: "Тролли — часть норвежского фольклора. Поселите их в музейном парке, у деревянной церкви или на знаменитом маршруте, и посетители задержатся дольше и увидят больше.",
      idea: "Тролль-сказочник у старой усадьбы, тролль с драконьей головой на ставкирке и тролль-скала, охраняющий смотровую площадку.",
      types: ["Музеи под открытым небом", "Музеи кораблей и истории", "Художественные музеи", "Ставкирки и соборы", "Национальные парки", "Известные маршруты и смотровые"],
    },
    transport: {
      name: "Транспорт и паромы",
      short: "Сделайте поездку частью охоты.",
      lead: "Паромы, скоростные катера, автобусы и поезда перевозят тысячи любопытных путешественников. Тролли на борту и на причале превращают ожидание в игру.",
      idea: "Морской тролль машет у носа парома, тролль-контролёр на остановке и тоннельный тролль, которого встретишь только в поезде.",
      types: ["Паромные компании", "Скоростные катера", "Региональные автобусы", "Поезда", "Городской транспорт", "Причалы и терминалы"],
    },
    cafes: {
      name: "Кафе и пекарни",
      short: "Свежие булочки, горячий кофе — и тролль у двери.",
      lead: "Один тролль у вашего кафе приводит игроков на кофе, вафли и булочки с корицей. Они могут сделать предзаказ через Vipps и забрать его, когда придут.",
      idea: "Тролль-пекарь с мукой на носу, принюхивающийся к булочкам с корицей через окно.",
      types: ["Местные кафе", "Пекарни", "Кофейные обжарочные", "Филиалы пекарен и кофеен", "Киоски с мороженым", "Вафельные домики"],
    },
    saunas: {
      name: "Сауны",
      short: "Согрейтесь после охоты.",
      lead: "После холодного дня на тропе нет ничего лучше сауны у фьорда. Банный тролль приводит игроков к вашей двери, а время можно забронировать через Vipps.",
      idea: "Весёлый тролль в полосатом полотенце парится на палубе и подбивает всех прыгнуть во фьорд.",
      types: ["Местные сауны", "Плавучие сауны", "Сауны у фьорда", "Банные клубы", "Спа и бани", "Горячие купели"],
    },
    shops: {
      name: "Небольшие магазины и местные производители",
      short: "Маленький магазин — большое открытие.",
      lead: "Охотники за троллями любят привозить что-то домой. Один тролль у вашего магазина отмечает вас на карте для всех, кто проезжает мимо.",
      idea: "Тролль-лавочник с корзиной варенья, сыра и шерстяных носков.",
      types: ["Фермерские лавки", "Сувениры и ремёсла", "Пивоварни и винокурни", "Рыболовные и туристические магазины", "Книжные и подарочные магазины", "Продукты, спорт и хозтовары"],
    },
  },
};

export default ru;
